import { Home } from "../CVContainer/Home/Home";
import { AboutMe } from "../CVContainer/AboutMe/AboutMe";
import { ContactUs } from "../CVContainer/ContactMe/ContactUs";
import { Resume } from "../CVContainer/Resume/Resume";
import { Tech } from "../CVContainer/Technolgies/Tech";
import { Projects } from "../CVContainer/Projects/Projects";
export const SCREEN_TOTAL = [
  {
    screen_name: "Home",
    component: Home,
  },
  {
    screen_name: "About Me",
    component: AboutMe,
  },
  {
    screen_name: "Projects",
    component: Projects,
  },

  {
    screen_name: "Technologies",
    component: Tech,
  },
  {
    screen_name: "CV",
    component: Resume,
  },
  {
    screen_name: "Contact Me",
    component: ContactUs,
  },
];

export const GET_SCREEN_INDEX = (screen_name) => {
  if (!screen_name) return -1;
  for (let i = 0; i < SCREEN_TOTAL.length; i++) {
    if (SCREEN_TOTAL[i].screen_name === screen_name) return i;
  }
  return -1;
};
